"use strict";

function _interopDefault(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var reactRouter = require("react-router"),
    React = _interopDefault(require("react")),
    history = require("history");

require("prop-types"), require("tiny-warning");

var invariant = _interopDefault(require("tiny-invariant"));

function _extends() {
  return (_extends = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var o in r) {
        Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function _inheritsLoose(e, t) {
  e.prototype = Object.create(t.prototype), _setPrototypeOf(e.prototype.constructor = e, t);
}

function _setPrototypeOf(e, t) {
  return (_setPrototypeOf = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function _objectWithoutPropertiesLoose(e, t) {
  if (null == e) return {};
  var r,
      o,
      n = {},
      a = Object.keys(e);

  for (o = 0; o < a.length; o++) {
    r = a[o], 0 <= t.indexOf(r) || (n[r] = e[r]);
  }

  return n;
}

var BrowserRouter = function (n) {
  function e() {
    for (var e, t = arguments.length, r = new Array(t), o = 0; o < t; o++) {
      r[o] = arguments[o];
    }

    return (e = n.call.apply(n, [this].concat(r)) || this).history = history.createBrowserHistory(e.props), e;
  }

  return _inheritsLoose(e, n), e.prototype.render = function () {
    return React.createElement(reactRouter.Router, {
      history: this.history,
      children: this.props.children
    });
  }, e;
}(React.Component),
    HashRouter = function (n) {
  function e() {
    for (var e, t = arguments.length, r = new Array(t), o = 0; o < t; o++) {
      r[o] = arguments[o];
    }

    return (e = n.call.apply(n, [this].concat(r)) || this).history = history.createHashHistory(e.props), e;
  }

  return _inheritsLoose(e, n), e.prototype.render = function () {
    return React.createElement(reactRouter.Router, {
      history: this.history,
      children: this.props.children
    });
  }, e;
}(React.Component),
    resolveToLocation = function resolveToLocation(e, t) {
  return "function" == typeof e ? e(t) : e;
},
    normalizeToLocation = function normalizeToLocation(e, t) {
  return "string" == typeof e ? history.createLocation(e, null, null, t) : e;
},
    forwardRefShim = function forwardRefShim(e) {
  return e;
},
    forwardRef = React.forwardRef;

function isModifiedEvent(e) {
  return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}

void 0 === forwardRef && (forwardRef = forwardRefShim);

var LinkAnchor = forwardRef(function (e, t) {
  var r = e.innerRef,
      o = e.navigate,
      n = e.onClick,
      a = _objectWithoutPropertiesLoose(e, ["innerRef", "navigate", "onClick"]),
      i = a.target,
      c = _extends({}, a, {
    onClick: function onClick(t) {
      try {
        n && n(t);
      } catch (e) {
        throw t.preventDefault(), e;
      }

      t.defaultPrevented || 0 !== t.button || i && "_self" !== i || isModifiedEvent(t) || (t.preventDefault(), o());
    }
  });

  return c.ref = forwardRefShim !== forwardRef && t || r, React.createElement("a", c);
}),
    Link = forwardRef(function (e, a) {
  var t = e.component,
      i = void 0 === t ? LinkAnchor : t,
      c = e.replace,
      u = e.to,
      f = e.innerRef,
      s = _objectWithoutPropertiesLoose(e, ["component", "replace", "to", "innerRef"]);

  return React.createElement(reactRouter.__RouterContext.Consumer, null, function (r) {
    r || invariant(!1);

    var o = r.history,
        e = normalizeToLocation(resolveToLocation(u, r.location), r.location),
        t = e ? o.createHref(e) : "",
        n = _extends({}, s, {
      href: t,
      navigate: function navigate() {
        var e = resolveToLocation(u, r.location),
            t = history.createPath(r.location) === history.createPath(normalizeToLocation(e));
        (c || t ? o.replace : o.push)(e);
      }
    });

    return forwardRefShim !== forwardRef ? n.ref = a || f : n.innerRef = f, React.createElement(i, n);
  });
}),
    forwardRefShim$1 = function forwardRefShim$1(e) {
  return e;
},
    forwardRef$1 = React.forwardRef;

function joinClassnames() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
    t[r] = arguments[r];
  }

  return t.filter(function (e) {
    return e;
  }).join(" ");
}

void 0 === forwardRef$1 && (forwardRef$1 = forwardRefShim$1);
var NavLink = forwardRef$1(function (e, s) {
  var t = e["aria-current"],
      l = void 0 === t ? "page" : t,
      r = e.activeClassName,
      p = void 0 === r ? "active" : r,
      R = e.activeStyle,
      h = e.className,
      y = e.exact,
      d = e.isActive,
      m = e.location,
      v = e.sensitive,
      b = e.strict,
      P = e.style,
      w = e.to,
      x = e.innerRef,
      g = _objectWithoutPropertiesLoose(e, ["aria-current", "activeClassName", "activeStyle", "className", "exact", "isActive", "location", "sensitive", "strict", "style", "to", "innerRef"]);

  return React.createElement(reactRouter.__RouterContext.Consumer, null, function (e) {
    e || invariant(!1);
    var t = m || e.location,
        r = normalizeToLocation(resolveToLocation(w, t), t),
        o = r.pathname,
        n = o && o.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1"),
        a = n ? reactRouter.matchPath(t.pathname, {
      path: n,
      exact: y,
      sensitive: v,
      strict: b
    }) : null,
        i = !!(d ? d(a, t) : a),
        c = "function" == typeof h ? h(i) : h,
        u = "function" == typeof P ? P(i) : P;
    i && (c = joinClassnames(c, p), u = _extends({}, u, R));

    var f = _extends({
      "aria-current": i && l || null,
      className: c,
      style: u,
      to: r
    }, g);

    return forwardRefShim$1 !== forwardRef$1 ? f.ref = s || x : f.innerRef = x, React.createElement(Link, f);
  });
});
Object.defineProperty(exports, "MemoryRouter", {
  enumerable: !0,
  get: function get() {
    return reactRouter.MemoryRouter;
  }
}), Object.defineProperty(exports, "Prompt", {
  enumerable: !0,
  get: function get() {
    return reactRouter.Prompt;
  }
}), Object.defineProperty(exports, "Redirect", {
  enumerable: !0,
  get: function get() {
    return reactRouter.Redirect;
  }
}), Object.defineProperty(exports, "Route", {
  enumerable: !0,
  get: function get() {
    return reactRouter.Route;
  }
}), Object.defineProperty(exports, "Router", {
  enumerable: !0,
  get: function get() {
    return reactRouter.Router;
  }
}), Object.defineProperty(exports, "StaticRouter", {
  enumerable: !0,
  get: function get() {
    return reactRouter.StaticRouter;
  }
}), Object.defineProperty(exports, "Switch", {
  enumerable: !0,
  get: function get() {
    return reactRouter.Switch;
  }
}), Object.defineProperty(exports, "generatePath", {
  enumerable: !0,
  get: function get() {
    return reactRouter.generatePath;
  }
}), Object.defineProperty(exports, "matchPath", {
  enumerable: !0,
  get: function get() {
    return reactRouter.matchPath;
  }
}), Object.defineProperty(exports, "useHistory", {
  enumerable: !0,
  get: function get() {
    return reactRouter.useHistory;
  }
}), Object.defineProperty(exports, "useLocation", {
  enumerable: !0,
  get: function get() {
    return reactRouter.useLocation;
  }
}), Object.defineProperty(exports, "useParams", {
  enumerable: !0,
  get: function get() {
    return reactRouter.useParams;
  }
}), Object.defineProperty(exports, "useRouteMatch", {
  enumerable: !0,
  get: function get() {
    return reactRouter.useRouteMatch;
  }
}), Object.defineProperty(exports, "withRouter", {
  enumerable: !0,
  get: function get() {
    return reactRouter.withRouter;
  }
}), exports.BrowserRouter = BrowserRouter, exports.HashRouter = HashRouter, exports.Link = Link, exports.NavLink = NavLink;